/* eslint-disable default-case */
import React from 'react';
import TabTitle from '../../pages/Member-Profile-Edit/TabTitle';
import BillingInformation from './BillingInformation';
import BillingHistoryTab from './BillingHistoryTab';

const BillingSettingsTabsContent = ({ activeTab, menuItems }) => {
  switch (activeTab) {
    case 0:
      return (
        <>
          <TabTitle title="Billing Information" />

          <BillingInformation />
        </>
      );

    case 1:
      return (
        <>
          <TabTitle title="Billing history" />

          <BillingHistoryTab />

        </>
      );

  }
};

export default BillingSettingsTabsContent;
